module.exports = __webpack_public_path__ + "static/media/volker-lotze.a427bdae.jpg";